import { ReactNode } from 'react';
import styled from 'styled-components';
import { AiColor16 } from 'ui/icons/aurora/16px/AiColor16';
import { ITBLDS_PREFIX } from '../constants';

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  width: min-content;
`;

export const addPredictiveGoalsIcon = (fieldName: string): Record<string, ReactNode> | undefined =>
  fieldName.startsWith(ITBLDS_PREFIX)
    ? {
        icon: (
          <IconWrapper>
            <AiColor16 />
          </IconWrapper>
        ),
      }
    : undefined;
